import React from "react";
import { Modal, Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiCogOutline, mdiBellOutline, mdiShieldCheckOutline } from "@mdi/js";
import "./clientBookingSettings.css";

const HowClientBookingWorksModal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="how-booking-works-modal-wrapper"
    >
      <Modal.Body className="pt-0">
        <Modal.Header className="modal-title-with-border" closeButton>
          <Modal.Title>How Client Booking Works</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-1 px-2">
          <div className="d-flex flex-column gap-4 p-0">
            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center justify-content-center">
                <Icon
                  path={mdiCogOutline}
                  size={1}
                  className="text-primary mt-1"
                />
              </div>
              <div>
                <p className="fw-semibold mb-1 how-booking-section-title">
                  Configure Your Schedule
                </p>
                <p className="mb-0">
                  Morph uses the settings to calculate your availability.
                  Clients will only see time slots that fit the specific rules
                  and tiers you define.
                </p>
              </div>
            </div>

            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center justify-content-center">
                <Icon
                  path={mdiBellOutline}
                  size={1}
                  className="text-primary mt-1"
                />
              </div>
              <div>
                <p className="fw-semibold mb-1 how-booking-section-title">
                  Share & Automate
                </p>
                <p className="mb-0">
                  Once turned on, share your link to accept bookings 24/7. When
                  a request comes in, Morph automatically:
                </p>
                <ul className="mt-1 mb-0">
                  <li>Blocks the time on your Job Calendar</li>
                  <li>Notifies you immediately</li>
                </ul>
              </div>
            </div>

            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center justify-content-center">
                <Icon
                  path={mdiShieldCheckOutline}
                  size={1}
                  className="text-primary mt-1"
                />
              </div>
              <div>
                <p className="fw-semibold mb-1 how-booking-section-title">
                  Verify & Finalize
                </p>
                <p className="mb-0">
                  You remain in full control. We recommend you:
                </p>
                <ul className="mt-1 mb-0">
                  <li>
                    Review details: Check the property detail and time, and call
                    the client to confirm access
                  </li>
                  <li>
                    Edit if needed: You can update the duration or reschedule
                    the job directly in your calendar
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={onHide}>
            Got it
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default HowClientBookingWorksModal;
